module.exports = __webpack_public_path__ + "static/media/flexion-extension-ratio-left.fb18ddb5.svg";